import React from 'react';
import { Link } from 'react-router-dom';
import TextTransition, { presets } from 'react-text-transition';
import { pageTitle } from '../../helpers/PageTitle';

const TEXTS = [
  'Creative Agency',
  'Marketing Agency',
  'Studio Agency',
  'Digital Agency',
  'Tech Startup',
];

export default function Landing() {
  const [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    const intervalId = setInterval(
      () => setIndex(index => index + 1),
      3000, // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);
  pageTitle('Zivan');
  return (
    <>
      {/* Start Hero */}
      <section
        className="cs_hero cs_style_6"
        style={{ backgroundImage: 'url("/images/landing/hero_bg.jpeg")' }}
      >
        <div className="container">
          <div className="cs_hero_text text-center position-relative">
            <div>
              <div className="cs_sliding_text cs_accent_color cs_fs_18 cs_medium cs_center">
                <TextTransition springConfig={presets.wobbly}>
                  {TEXTS[index % TEXTS.length]}
                </TextTransition>
              </div>
            </div>
            <div className="cs_height_10 cs_height_lg_10" />
            <h1 className="cs_hero_title cs_white_color cs_fs_68 cs_dancing_animation">
              Build Your Professional <br />
              Website With <span>Zivan</span> Template
              <svg
                width={84}
                height={77}
                viewBox="0 0 84 77"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M64.8361 15.0077C60.9794 17.106 57.7008 20.1709 53.9802 22.4975C50.3325 24.7755 46.9324 27.5247 43.6247 30.235C36.9169 35.7188 30.7919 42.1594 26.6584 49.8047C26.1096 50.8198 27.4502 51.9224 28.2856 51.0578C34.192 44.9038 40.2586 38.9148 46.4273 33.0376C49.429 30.1686 52.4729 27.3369 55.5588 24.5424C58.8228 21.594 62.5677 19.1994 65.7881 16.2414C66.4584 15.6197 65.5986 14.59 64.8361 15.0077Z"
                  fill="#4F4747"
                />
                <path
                  d="M82.3815 43.7792C77.9911 43.7566 73.6406 44.8596 69.2592 45.1026C64.965 45.3382 60.6605 46.106 56.4556 46.8842C47.9344 48.4516 39.4622 51.1383 32.1532 55.8409C31.1827 56.4653 31.8251 58.0778 32.974 57.7236C41.1165 55.1824 49.3197 52.8633 57.5584 50.6912C61.5718 49.6263 65.6042 48.6144 69.6554 47.6553C73.9369 46.6475 78.3724 46.3566 82.6202 45.3192C83.5073 45.098 83.251 43.7812 82.3815 43.7792Z"
                  fill="#4F4747"
                />
                <path
                  d="M32.2965 0.725815C30.183 4.5741 29.0778 8.92398 27.202 12.891C25.3612 16.7778 23.9834 20.9275 22.6622 24.9946C19.9763 33.2319 18.2976 41.9599 18.9456 50.6269C19.0316 51.7777 20.7553 51.9821 20.9918 50.8033C22.6412 42.4345 24.5147 34.1181 26.5343 25.8407C27.5122 21.8052 28.5457 17.7784 29.6347 13.7601C30.7905 9.51621 32.6501 5.47883 33.7639 1.25037C33.9925 0.365169 32.7129 -0.0374869 32.2965 0.725815Z"
                  fill="#4F4747"
                />
              </svg>
            </h1>
            <p className="cs_hero_subtitle cs_semibold cs_fs_21 cs_dancing_animation cs_white_color mb-0">
              <span className="cs_accent_color">10+</span> Unique Home,{' '}
              <span className="cs_accent_color">36+</span> Inner Pages with{' '}
              <span className="cs_accent_color">Dark</span> &amp;{' '}
              <span className="cs_accent_color">Light</span> Version
            </p>
            <a href="#demo" className="cs_down_btn" />
          </div>
        </div>
      </section>
      {/* End Hero */}
      {/* Start Scrolling Effect */}
      <div className="cs_moving_text_wrap cs_style_2 cs_fs_38 cs_bold cs_primary_font cs_primary_color cs_accent_bg">
        <div className="cs_moving_text_in">
          <div className="cs_moving_text">
            <svg
              width={30}
              height={30}
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 13.468C0.0859599 13.4758 0.17192 13.4836 0.25788 13.4836C3.86038 13.4836 7.46288 13.4836 11.0732 13.4836C11.1513 13.4836 11.2295 13.4836 11.292 13.4836C8.61943 10.8103 5.94686 8.13705 3.2821 5.4716C4.04011 4.72121 4.73561 4.04117 5.44673 3.33768C8.08023 5.97186 10.7528 8.64513 13.4957 11.3887C13.4957 7.53517 13.4957 3.76759 13.4957 0C14.5116 0 15.4962 0 16.5043 0C16.5043 3.7754 16.5043 7.52736 16.5043 11.2715C19.1769 8.59823 21.8494 5.92496 24.4986 3.27514C25.2566 4.03335 25.9443 4.72121 26.6476 5.4247C24.0141 8.05889 21.3415 10.7322 18.6689 13.4054C18.6767 13.4289 18.6924 13.4523 18.7002 13.4758C22.459 13.4758 26.2256 13.4758 30 13.4758C30 14.4919 30 15.4768 30 16.493C26.2256 16.493 22.4668 16.493 18.6767 16.493C21.3806 19.1975 24.0453 21.863 26.7101 24.5284C25.9755 25.2475 25.2878 25.9276 24.5845 26.6232C21.951 23.9891 19.2785 21.3158 16.559 18.5878C16.5434 18.7363 16.5277 18.7989 16.5277 18.8614C16.5277 22.5039 16.5277 26.1464 16.5277 29.7968C16.5277 29.8671 16.5434 29.9297 16.5434 30C15.5275 30 14.5116 30 13.4957 30C13.5035 29.914 13.5113 29.828 13.5113 29.7421C13.5113 26.1386 13.5113 22.5352 13.5113 18.9317C13.5113 18.8536 13.4957 18.7676 13.4879 18.5956C10.745 21.3236 8.07242 23.9969 5.43892 26.6311C4.73561 25.9354 4.04011 25.2553 3.27429 24.505C5.93905 21.8395 8.6038 19.174 11.2764 16.5008C11.2217 16.5008 11.1435 16.5008 11.0654 16.5008C7.46288 16.5008 3.86038 16.5008 0.25788 16.5008C0.17192 16.5008 0.0859599 16.5164 0 16.5164C0 15.5003 0 14.4841 0 13.468Z"
                fill="#0A0A17"
              />
            </svg>
            Zivan - Creative Agency Responsive React Template With Dark & Light
            Version
            <svg
              width={30}
              height={30}
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 13.468C0.0859599 13.4758 0.17192 13.4836 0.25788 13.4836C3.86038 13.4836 7.46288 13.4836 11.0732 13.4836C11.1513 13.4836 11.2295 13.4836 11.292 13.4836C8.61943 10.8103 5.94686 8.13705 3.2821 5.4716C4.04011 4.72121 4.73561 4.04117 5.44673 3.33768C8.08023 5.97186 10.7528 8.64513 13.4957 11.3887C13.4957 7.53517 13.4957 3.76759 13.4957 0C14.5116 0 15.4962 0 16.5043 0C16.5043 3.7754 16.5043 7.52736 16.5043 11.2715C19.1769 8.59823 21.8494 5.92496 24.4986 3.27514C25.2566 4.03335 25.9443 4.72121 26.6476 5.4247C24.0141 8.05889 21.3415 10.7322 18.6689 13.4054C18.6767 13.4289 18.6924 13.4523 18.7002 13.4758C22.459 13.4758 26.2256 13.4758 30 13.4758C30 14.4919 30 15.4768 30 16.493C26.2256 16.493 22.4668 16.493 18.6767 16.493C21.3806 19.1975 24.0453 21.863 26.7101 24.5284C25.9755 25.2475 25.2878 25.9276 24.5845 26.6232C21.951 23.9891 19.2785 21.3158 16.559 18.5878C16.5434 18.7363 16.5277 18.7989 16.5277 18.8614C16.5277 22.5039 16.5277 26.1464 16.5277 29.7968C16.5277 29.8671 16.5434 29.9297 16.5434 30C15.5275 30 14.5116 30 13.4957 30C13.5035 29.914 13.5113 29.828 13.5113 29.7421C13.5113 26.1386 13.5113 22.5352 13.5113 18.9317C13.5113 18.8536 13.4957 18.7676 13.4879 18.5956C10.745 21.3236 8.07242 23.9969 5.43892 26.6311C4.73561 25.9354 4.04011 25.2553 3.27429 24.505C5.93905 21.8395 8.6038 19.174 11.2764 16.5008C11.2217 16.5008 11.1435 16.5008 11.0654 16.5008C7.46288 16.5008 3.86038 16.5008 0.25788 16.5008C0.17192 16.5008 0.0859599 16.5164 0 16.5164C0 15.5003 0 14.4841 0 13.468Z"
                fill="#0A0A17"
              />
            </svg>
            Zivan - Creative Agency Responsive React Template With Dark & Light
            Version
          </div>
          <div className="cs_moving_text">
            <svg
              width={30}
              height={30}
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 13.468C0.0859599 13.4758 0.17192 13.4836 0.25788 13.4836C3.86038 13.4836 7.46288 13.4836 11.0732 13.4836C11.1513 13.4836 11.2295 13.4836 11.292 13.4836C8.61943 10.8103 5.94686 8.13705 3.2821 5.4716C4.04011 4.72121 4.73561 4.04117 5.44673 3.33768C8.08023 5.97186 10.7528 8.64513 13.4957 11.3887C13.4957 7.53517 13.4957 3.76759 13.4957 0C14.5116 0 15.4962 0 16.5043 0C16.5043 3.7754 16.5043 7.52736 16.5043 11.2715C19.1769 8.59823 21.8494 5.92496 24.4986 3.27514C25.2566 4.03335 25.9443 4.72121 26.6476 5.4247C24.0141 8.05889 21.3415 10.7322 18.6689 13.4054C18.6767 13.4289 18.6924 13.4523 18.7002 13.4758C22.459 13.4758 26.2256 13.4758 30 13.4758C30 14.4919 30 15.4768 30 16.493C26.2256 16.493 22.4668 16.493 18.6767 16.493C21.3806 19.1975 24.0453 21.863 26.7101 24.5284C25.9755 25.2475 25.2878 25.9276 24.5845 26.6232C21.951 23.9891 19.2785 21.3158 16.559 18.5878C16.5434 18.7363 16.5277 18.7989 16.5277 18.8614C16.5277 22.5039 16.5277 26.1464 16.5277 29.7968C16.5277 29.8671 16.5434 29.9297 16.5434 30C15.5275 30 14.5116 30 13.4957 30C13.5035 29.914 13.5113 29.828 13.5113 29.7421C13.5113 26.1386 13.5113 22.5352 13.5113 18.9317C13.5113 18.8536 13.4957 18.7676 13.4879 18.5956C10.745 21.3236 8.07242 23.9969 5.43892 26.6311C4.73561 25.9354 4.04011 25.2553 3.27429 24.505C5.93905 21.8395 8.6038 19.174 11.2764 16.5008C11.2217 16.5008 11.1435 16.5008 11.0654 16.5008C7.46288 16.5008 3.86038 16.5008 0.25788 16.5008C0.17192 16.5008 0.0859599 16.5164 0 16.5164C0 15.5003 0 14.4841 0 13.468Z"
                fill="#0A0A17"
              />
            </svg>
            Zivan - Creative Agency Responsive React Template With Dark & Light
            Version
            <svg
              width={30}
              height={30}
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 13.468C0.0859599 13.4758 0.17192 13.4836 0.25788 13.4836C3.86038 13.4836 7.46288 13.4836 11.0732 13.4836C11.1513 13.4836 11.2295 13.4836 11.292 13.4836C8.61943 10.8103 5.94686 8.13705 3.2821 5.4716C4.04011 4.72121 4.73561 4.04117 5.44673 3.33768C8.08023 5.97186 10.7528 8.64513 13.4957 11.3887C13.4957 7.53517 13.4957 3.76759 13.4957 0C14.5116 0 15.4962 0 16.5043 0C16.5043 3.7754 16.5043 7.52736 16.5043 11.2715C19.1769 8.59823 21.8494 5.92496 24.4986 3.27514C25.2566 4.03335 25.9443 4.72121 26.6476 5.4247C24.0141 8.05889 21.3415 10.7322 18.6689 13.4054C18.6767 13.4289 18.6924 13.4523 18.7002 13.4758C22.459 13.4758 26.2256 13.4758 30 13.4758C30 14.4919 30 15.4768 30 16.493C26.2256 16.493 22.4668 16.493 18.6767 16.493C21.3806 19.1975 24.0453 21.863 26.7101 24.5284C25.9755 25.2475 25.2878 25.9276 24.5845 26.6232C21.951 23.9891 19.2785 21.3158 16.559 18.5878C16.5434 18.7363 16.5277 18.7989 16.5277 18.8614C16.5277 22.5039 16.5277 26.1464 16.5277 29.7968C16.5277 29.8671 16.5434 29.9297 16.5434 30C15.5275 30 14.5116 30 13.4957 30C13.5035 29.914 13.5113 29.828 13.5113 29.7421C13.5113 26.1386 13.5113 22.5352 13.5113 18.9317C13.5113 18.8536 13.4957 18.7676 13.4879 18.5956C10.745 21.3236 8.07242 23.9969 5.43892 26.6311C4.73561 25.9354 4.04011 25.2553 3.27429 24.505C5.93905 21.8395 8.6038 19.174 11.2764 16.5008C11.2217 16.5008 11.1435 16.5008 11.0654 16.5008C7.46288 16.5008 3.86038 16.5008 0.25788 16.5008C0.17192 16.5008 0.0859599 16.5164 0 16.5164C0 15.5003 0 14.4841 0 13.468Z"
                fill="#0A0A17"
              />
            </svg>
            Zivan - Creative Agency Responsive React Template With Dark & Light
            Version
          </div>
        </div>
      </div>
      {/* End Scrolling Effect */}

      {/* Start Main Demo */}
      <section className="cs_primary_bg_2" id="demo">
        <div className="cs_height_143 cs_height_lg_75" />
        <div className="container">
          <div className="cs_section_heading cs_style_1 text-center">
            <p className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0">
              Home Demos
            </p>
            <div className="cs_height_10 cs_height_lg_5" />
            <h2 className="cs_section_title cs_fs_50 mb-0 cs_white_color">
              Stunning 10 Home Pages
            </h2>
          </div>
          <div className="cs_height_85 cs_height_lg_50" />
        </div>
        <div className="cs_plr_130">
          <div className="row cs_gap_y_65 cs_row_gap_40">
            <div className="col-lg-4 col-sm-6">
              <Link to="/" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home2.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Creative Agency
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/light" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home1.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Creative Agency (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/marketing-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home4.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Marketing Agency
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/marketing-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home3.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Marketing Agency (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/studio-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home6.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Studio Agency
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/studio-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home5.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Studio Agency (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/digital-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home8.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Digital Agency
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/digital-agency"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home7.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Digital Agency (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/tech-startup" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home9.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Tech Startup
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/tech-startup"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/home10.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Tech Startup (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/comingsoon.jpg"
                  alt="Demo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cs_height_140 cs_height_lg_70" />
      </section>
      {/* End Main Demo */}

      {/* Start Inner Page Demo */}
      <section className="cs_primary_bg">
        <div className="cs_height_143 cs_height_lg_75" />
        <div className="container">
          <div className="cs_section_heading cs_style_1 text-center">
            <p
              className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0 wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
            >
              Inner Pages
            </p>
            <div className="cs_height_10 cs_height_lg_5" />
            <h2 className="cs_section_title cs_fs_50 mb-0 cs_white_color">
              Unique 24 Inner Pages
            </h2>
          </div>
          <div className="cs_height_85 cs_height_lg_50" />
        </div>
        <div className="cs_plr_130">
          <div className="row cs_gap_y_65 cs_row_gap_40">
            <div className="col-lg-4 col-sm-6">
              <Link to="/about" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page2.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  About
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/light/about" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page1.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  About (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/service" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page4.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Service
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/service"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page3.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Service (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/service/service-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page6.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Service Details
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/service/service-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page5.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Service Details (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/portfolio" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page8.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Portfolio
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/portfolio"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page7.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Portfolio (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/portfolio/portfolio-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page10.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Portfolio Details
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/portfolio/portfolio-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page9.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Portfolio Details (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/case-study-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page12.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Case Study Detaiils
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/case-study-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page11.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Case Study Details (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/team" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page14.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Team
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/light/team" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page13.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Team (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/team/team-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page16.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Team Details
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/team/team-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page15.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Team Details (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/blog-list" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page18.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog List
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/blog-list"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page17.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog List (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/blog" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page20.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog Standard
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/light/blog" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page19.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog Standard (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/blog/blog-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page22.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog Single
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/blog/blog-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page21.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Blog Single (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/contact" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page24.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Contact
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/contact"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/demo/inner_page23.jpg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Contact (Light)
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="cs_height_140 cs_height_lg_70" />
      </section>
      {/* End Inner Page Demo */}

      {/* Start Shop Demo */}
      <section className="cs_primary_bg_2" id="shop">
        <div className="cs_height_143 cs_height_lg_75" />
        <div className="container">
          <div className="cs_section_heading cs_style_1 text-center">
            <p
              className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0 wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
            >
              Shop Pages
            </p>
            <div className="cs_height_10 cs_height_lg_5" />
            <h2 className="cs_section_title cs_fs_50 mb-0 cs_white_color">
              eCommerce Ready
            </h2>
          </div>
          <div className="cs_height_85 cs_height_lg_50" />
        </div>
        <div className="cs_plr_130">
          <div className="row cs_gap_y_65 cs_row_gap_40">
            <div className="col-lg-4 col-sm-6">
              <Link to="/shop" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/1_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Product Grid
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/light/shop" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/1.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Product Grid (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/shop/product-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/2_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Product Single
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/shop/product-details"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/2.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Product Single (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/shop/cart" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/3_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Cart
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/shop/cart"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/3.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Cart (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/shop/checkout"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/4_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Checkout
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/shop/checkout"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/4.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Checkout (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link to="/shop/success" target="_blank" className="cs_demo_card">
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/5_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Order Received
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/shop/success"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/5.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Order Received (Light)
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/shop/wishlist"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/6_dark.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Wishlist
                </span>
              </Link>
            </div>
            <div className="col-lg-4 col-sm-6">
              <Link
                to="/light/shop/wishlist"
                target="_blank"
                className="cs_demo_card"
              >
                <img
                  className="cs_demo_card_thumb"
                  src="/images/landing/shop/6.jpeg"
                  alt="Demo"
                />
                <span className="cs_demo_card_title cs_fs_21 cs_semibold cs_primary_font">
                  Wishlist (Light)
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="cs_height_140 cs_height_lg_70" />
      </section>
      {/* End Shop Demo */}
      {/* Start Features */}
      <div className="position-relative cs_shape_animation_4">
        <div className="cs_shape_1" />
        <div className="cs_height_143 cs_height_lg_75" />
        <div className="container">
          <div className="cs_section_heading cs_style_1 text-center">
            <p
              className="cs_section_subtitle cs_accent_color cs_fs_18 mb-0 wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
            >
              Template Features
            </p>
            <div className="cs_height_10 cs_height_lg_5" />
            <h2 className="cs_section_title cs_fs_50 mb-0">
              Popular Features With Latest <br /> Technology
            </h2>
          </div>
          <div className="cs_height_85 cs_height_lg_45" />
          <div className="row">
            <div className="cs_icon_7_wrap">
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_1.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Bootstarp 5</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_2.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">HTML5</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_3.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">CSS3</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_4.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">jQuery</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_15.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Modern Animation</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_5.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Light &amp; Dark UI</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_6.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Sass File</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_7.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">SEO Friendly</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_8.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Scroll Effect</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_9.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Documentation</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_10.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Fast Page Loading</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_11.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Working Contact Form</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_12.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">W3 Validation</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_13.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">Responsive Design</p>
              </div>
              <div className="cs_iconbox cs_style_7 text-center">
                <div className="cs_iconbox_icon">
                  <img
                    src="/images/landing/features-icon/icon_14.svg"
                    alt="Icon"
                  />
                </div>
                <p className="cs_fs_18 mb-0">24/7 Support</p>
              </div>
            </div>
          </div>
        </div>
        <div className="cs_height_150 cs_height_lg_80" />
      </div>
      {/* End Features */}

      {/* Start Footer */}
      <footer className="cs_fooer_2 cs_primary_bg">
        <div className="cs_cta cs_style_4 text-center position-relative">
          <div className="cs_cta_shape_1 position-absolute">
            <svg
              width={56}
              height={41}
              viewBox="0 0 56 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.5"
                d="M54.6623 32.7347C51.6789 37.0618 42.174 43.3879 39.7899 34.8097C38.5284 30.2359 42.1235 24.5172 42.5966 19.9687C43.2904 13.2821 39.443 5.41874 31.9059 6.05135C31.3586 6.10385 30.8151 6.19047 30.2786 6.31072C29.0008 4.21019 27.1618 2.5107 24.9702 1.40489C22.7785 0.299087 20.3219 -0.168816 17.8786 0.0542238C10.5497 0.743766 4.78487 7.39247 1.87094 13.6616C-0.232587 17.9159 -0.57711 22.831 0.91224 27.3386C1.4925 28.9897 3.99646 28.3381 3.54865 26.6111C1.80786 19.994 6.02739 12.4976 10.5938 7.99978C15.1602 3.50194 22.6216 2.572 26.3618 7.71511C21.7891 9.96086 17.702 14.1614 15.0719 17.957C11.9183 22.5245 8.62595 31.3746 14.6493 35.2589C20.4835 39.0165 27.1881 36.5241 30.4552 30.8306C33.7917 24.9727 33.716 16.9828 32.1077 10.6251C31.9079 9.84013 31.6464 9.07227 31.3256 8.32873C34.2647 7.65817 37.0778 8.80319 38.9447 11.7765C41.9217 16.502 40.4017 21.6009 38.9825 26.5289C37.6391 31.1785 36.1317 38.618 42.3884 40.5728C47.8757 42.2935 54.0946 38.6054 55.9552 33.2978C56.2391 32.507 55.0975 32.1085 54.6623 32.7347ZM27.2953 28.0345C26.1095 30.7231 24.0218 32.7537 20.9881 32.9751C15.8036 33.3547 14.8133 29.0909 15.9423 25.0739C17.5822 19.3298 22.6973 13.4845 27.6106 10.0684C27.6364 10.1199 27.6596 10.1727 27.68 10.2266C29.7448 16.0071 29.6078 22.349 27.2953 28.0345Z"
                fill="#4F4747"
              />
            </svg>
          </div>
          <div className="cs_cta_shape_2 position-absolute">
            <svg
              width={71}
              height={50}
              viewBox="0 0 71 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.5"
                d="M67.9997 3.52644C67.7916 9.52081 62.1524 23.0613 53.9573 18.8847C49.5979 16.6488 49.5122 9.04938 46.9688 5.22142C43.2281 -0.404541 33.9921 -2.68958 26.5961 4.78165C26.0635 5.32903 25.5575 5.8983 25.0812 6.48617C22.3546 6.10803 19.3135 6.5498 16.3025 7.7614C13.2916 8.97301 10.4313 10.906 8.0458 13.3413C0.903713 20.6616 -0.640811 30.9689 0.518557 38.3457C1.17451 43.4688 4.09576 47.4505 8.64746 49.4255C10.3507 50.1167 12.5133 47.3058 10.8968 46.435C4.6772 43.122 4.05343 33.6183 5.78967 26.0264C7.52592 18.4345 14.645 10.812 21.9553 11.1701C18.7103 17.09 17.2729 24.0152 17.0767 29.2857C16.8523 35.6173 19.3408 45.2684 28.1796 42.5681C36.7378 39.9493 42.0295 31.8656 41.6205 24.5897C41.1738 17.1267 35.7656 11.2445 29.8564 8.00169C29.1255 7.60245 28.3421 7.27327 27.5134 7.01724C30.1147 3.78798 33.7963 2.0285 37.7162 2.50972C43.9563 3.26548 45.7809 8.47585 47.5961 13.4652C49.3042 18.177 52.7032 25.1194 60.497 20.7649C67.3365 16.9506 71.327 8.42728 69.7165 2.74508C69.4834 1.89236 68.0334 2.65568 67.9997 3.52644ZM36.4777 25.4412C37.0412 28.5455 36.2303 31.9972 33.2312 34.9797C28.1067 40.0775 24.2354 37.8207 22.7268 33.7794C20.5962 27.977 22.0028 18.8716 24.8205 11.7635C24.8815 11.7779 24.9408 11.7958 24.9979 11.8169C30.9956 14.2058 35.0839 19.0578 36.4777 25.4412Z"
                fill="#4F4747"
              />
            </svg>
          </div>
          <div className="container">
            <h2 className="cs_cta_title cs_fs_68">
              Grab <span className>Zivan</span> and Create a <br />
              Professional Website Today!
            </h2>
            <p className="cs_cta_subtitle cs_fs_18">
              Pay one-time &amp;­ get­ free­ life­ time­ license­ and­ update
            </p>
            <Link
              target="_blank"
              to="/landing"
              className="cs_btn cs_style_1 cs_btn_white"
            >
              Purchase Now{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
        <div className="container">
          <div className="cs_bottom_footer">
            <div className="cs_bottom_footer_left">
              <img src="/images/logo_white.svg" alt="Logo" />
            </div>
            <div className="cs_bottom_footer_right">
              <div className="cs_copyright">
                Laralink © 2023 All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* End Footer */}
    </>
  );
}
